export const saveItem = (posicion, idTorneo, codEtapa) => {
  return {
    idTorneo: idTorneo ?? null,
    codEtapa: codEtapa ?? null,
    zona: posicion.zona ?? null,
    posicion: posicion.posicion ?? null,
    idEquipo: posicion.equipo?.id ?? null,
    puntos: posicion.puntos ?? 0,
    partidosJugados: posicion.partidosJugados ?? 0,
    partidosGanados: posicion.partidosGanados ?? 0,
    partidosEmpatados: posicion.partidosEmpatados ?? 0,
    partidosPerdidos: posicion.partidosPerdidos ?? 0,
    golesAFavor: posicion.golesAFavor ?? 0,
    golesEnContra: posicion.golesEnContra ?? 0,
  };
};
